var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setup-page"},[_c('meeting-setup'),_vm._v(" "),_c('motion-setup',{attrs:{"meeting":_vm.meeting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }